/**
 * Selector function for retrieving logging settings from the application state.
 * @param state - The application state.
 * @returns An object with logging settings.
 */
export const applicationGetLoggingSettings = (state: any) => state.application.logging;
